<template>
  <div>
    <div class="playerbg">
         <div class="title">
            <div class="han">培训列表</div>
            <div class="eng">Train</div>
        </div>
        <div class="header">
        <div class="status">
            <div class="status-cell" v-for="(status,index) in statusList" :key="index" :class="params.status == status.code? 'activeBg':'inactiveBg' " @click="statusSwitch(index,status.code)">{{status.name}}</div>
        </div>
        <div class="search">
            <input class="search-input" type="text" placeholder="请输入培训名称搜索" v-model="searchVal">
            <span class="search-btn"  @click="search()">搜索</span>
            <img class="search-icon" src="../../../assets/search_icon.png" alt="" >
        </div>
    </div>
    <div class="type-box">
        <div class="type-name" @click="changeType(-1)" :style="{color: params.type === -1 ? 'red' : '#fff'}">全部</div>
        <div class="type-name" @click="changeType(1)" :style="{color: params.type === 1 ? 'red' : '#fff'}">教练培训</div>
        <div class="type-name" @click="changeType(2)" :style="{color: params.type === 2 ? 'red' : '#fff'}">裁判培训</div>
        <div class="type-name" @click="changeType(3)" :style="{color: params.type === 3 ? 'red' : '#fff'}">夏令营</div>
        <div class="type-name" @click="changeType(4)" :style="{color: params.type === 4 ? 'red' : '#fff'}">讲座</div>
    </div>
    </div>
   <!--近期赛事-->
   <div style="background-color: #f4f4f4;width: 100%;min-height: 600px;">
        <div class="content">
            <MatchList v-if="websitePageMatchList.length>0" :websitePageMatchList="websitePageMatchList" v-for="(item, index) in websitePageMatchList" :key="index" :item="item"/>
            <div class="empty" v-else>
            暂无赛事
            </div>
            
        </div>
        <div class="pages" style="text-align: center;padding: 30px 0;" v-if="websitePageMatchList.length !==0">
            <a-pagination v-model="current" :total="totalNum" :defaultPageSize="params.pageSize" show-less-items @change="onChange"/>
        </div>
    </div>
  
  </div>
</template>

<script>
import matchFun from '@comm/utils/matchFun'
import MatchList from '@comm/components/MatchList'
export default {
  name: 'ExaminCoach',
  components: {
    MatchList,
  },
  data () {
    return {
      matchFun: matchFun,
      websitePageMatchList: [], // 赛事列表，
      totalNum: 0,
      params: {
        programId: -1,
        pageNum: 1,
        pageSize: 20,
        title: '',
        type: -1,
        status: -1
      },
      statusList: [
        {code: -1, name: '全部'},
        {code: 1, name: '计划中', bgColor: '#b99523'},
        {code: 2, name: '报名中', bgColor: '#F73C13'},
        {code: 3, name: '进行中', bgColor: '#008000'},
        {code: 4, name: '已结束', bgColor: '#BBB'}
      ],
      current: 1,
      searchVal: null,
      activeStatus: 0
    }
  },
  created: function () {
    this.findData()
  },
  methods: {
    findData () {
      this.$api.examin.examinPointList(this.params).then(res => {
        if (res.status === 0) {
          this.websitePageMatchList = res.data
          this.totalNum = res.total
        }
      }).catch(err => {
        console.log(err)
      })
    },
    onChange (page) {
      this.params.pageNum = page
      this.findData()
    },
    search () {
      this.params.type = -1
      this.params.status = -1
      this.params.pageNum = 1
      this.params.title = ''
      if (this.searchVal !== '' && this.searchVal !== undefined && this.searchVal !== null) {
        this.params.title = this.searchVal
      }
      this.findData()
    },
    statusSwitch (index, code) {
      this.params.pageNum = 1
      this.activeStatus = index
      this.params.status = code
      this.findData()
    },
    matchClick (id, programId) {
      this.$router.push({name: 'ActivitySign', query: {id: id, programId: programId}})
    },
    changeType (type) {
      this.params.type = type
      this.params.pageNum = 1
      this.findData()
    }
  }
}
</script>

<style lang="scss" scoped>
.inactiveBg{
  color: #000;
}
.activeBg{
    color: #b01f23;
    border-bottom: 2px solid #b01f23;
    font-weight: bold;
}
.playerbg{
    height: 320px;
    width: 100%;
    padding-top: 90px;
    background-image: url('../../../assets/weapon/playertopbg.jpg');
    position: relative;
    margin-top:-60px;
    top:0;
    left: 0;
}
.title{
    width: 1200px;
    margin: 0 auto;
    border-radius: 10px;
    color: #FFFFFF;
    padding: 20px 0 20px 10px;
    .han{
        font-size: 20px;
        margin-right: 10px;
        width: 100px;
        color: #FFFFFF;
        font-weight: bold;
    }
    .eng{
        font-size: 20px;
        width: 160px;
        color: #FFFFFF;
    }
}
.header{
  width: 1200px;
  padding: 40px;
  box-sizing: border-box;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background: rgb(236, 236, 236);
  border-radius: 10px;
}
.type-box{
  width: 1200px;
  padding: 10px 0 20px 0;
  margin: 0 auto;
}
.type-name{
  width:100px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  float: left;
  cursor: pointer;
  color: #fff;
}
.search{
  position: relative;
}
.search-input{
  width: 350px;
  padding-left: 50px;
  margin-left: 30px;
  border: 0px;
  height: 50px;
  outline: none;
  border-bottom: 1px solid #b3b3b3;
  font-size: 13px;
}
.search-icon{
  width: 17px;
  position:absolute;
  left: 40px;
  top: 15px;
}
.han{
  font-size: 20px;
  margin-right: 10px;
  font-weight: bold ;
}
.eng{
  font-size: 20px;
}
.title{
  height: 31px;
  color: #333;
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;
}
.status{
  flex: 2;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  color: #000;
}
.status-cell{
  // width: 18%;
  flex: 1;
  margin-right: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 13px;
  padding: 5px 0;
  cursor: pointer;
  max-width: 40px;
}
.head-font{
  width: 1200px;margin: 0 auto;margin-top:40px;margin-bottom:15px;font-size:18px;color:#000;
}
.match-list{
  overflow: hidden;
}
/**赛事列表*/
.match-list-warp {
    width: 100%;
    background-color: #f4f4f4;
    padding-top: 10px;
    margin-bottom: 40px;
    padding-bottom: 10px;
    overflow: hidden;
    min-height: 500px;
}
.match-list-warp .width-50 {
  width: 50%;
  float: left;
  position: relative;
}
.match-list-warp .width-50:nth-child(even) .btn {
  margin-left: 4%;
}
.match-list-warp .match-warp {
  background-color: #fff;
  width: 96%;
  height: 150px;
  margin-top: 10px;
  margin-bottom: 20px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
      -ms-flex-direction: row;
          flex-direction: row;
  padding: 0 20px;
}
.match-list-warp .match-warp .logo {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  margin-right: 20px;
}
.match-list-warp .match-warp .match-text {
  width: 436px;
  height: 100px;
}
.match-list-warp .match-warp .match-text p.title {
  font-size: 18px;
  font-weight: bold;
  text-align: left;
  overflow: hidden;
  height: 30px;
}
.match-list-warp .match-warp .match-text p {
  margin: 0;
  padding: 0;
}
.match-list-warp .match-warp .match-text p img.icon {
  height: 17px;
  width: 17px;
  margin-right: 10px;
}
.match-list-warp .match-warp .match-text .date-img {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  margin-top: 5px;
}
.match-list-warp .match-warp .match-text .date-img .date {
  -webkit-box-flex: 1.5;
      -ms-flex: 1.5;
          flex: 1.5;
}
.match-list-warp .match-warp .match-text .date-img label {
  -webkit-box-flex: 1;
      -ms-flex: 1;
          flex: 1;
  color: #999999;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
}
.match-list-warp .match-warp .match-text .date-img .center {
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
}
.match-list-warp .match-warp .match-text .date-img .right {
  -webkit-box-pack: end;
      -ms-flex-pack: end;
          justify-content: flex-end;
}
.match-list-warp .btn {
  cursor: pointer;
  position: absolute;
  bottom: 20px;
  right: 4%;
  border-bottom: 35px solid #b01f23;
  border-left: 15px solid rgba(255, 255, 255, 0);
  height: 0;
  width: 120px;
  color: #fff;
  text-align: center;
  line-height: 35px;
}
.match-list-warp .btn:hover {
  color: #eee;
  font-size: 16px;
}
.match-list-warp .more {
  color: #000;
  text-align: center;
  font-weight: bold;
  line-height: 30px;
  margin-top: 30px;
  font-size: 16px;
  cursor: pointer;
}
.match-list-warp .more:hover {
  color: #999999;
}
.match-list-warp .empty {
  text-align: center;
  color: #999;
  line-height: 150px;
  font-size: 16px;
}
.main-width {
  width: 1200px;
  margin-left: auto;
  margin-right: auto;
}
.search-btn{
    padding-top: 15px;
    padding-bottom: 15px;
    padding-left: 30px;
    padding-right: 30px;
    text-align: center;
    background: #b01f23;
    color:white;
    cursor: pointer;
}
//列表页
.content{
    width: 1200px;
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    flex-direction: row;
  }
  .empty{
    width: 100%;
    margin-top: 100px;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/daoba-match/views/layout/components/ActivityContent.vue